<script setup>
import { Copy } from '@lucide/vue'

import { useCopy } from './audit-copy.js'
import { shortId, useAuditText } from './audit-text.js'

defineProps({ id: { type: String, required: true } })

const { tr } = useAuditText()
const copy = useCopy()
</script>

<template>
  <button type="button" class="au-id" :title="id" :aria-label="tr('copyId', { id })" @click.stop.prevent="copy(id)">
    <span>{{ shortId(id) }}</span><Copy :size="12" aria-hidden="true" />
  </button>
</template>
